import React from 'react';
import useWithStore from "@/Hooks/useWithStore";
import CatalogCard from "@/Components/Site/CatalogCard";
import {isDesktop, isMobile} from "@/Helpers/Function";
import CardModel from "@/Pages/All/CardModel";
import Link from "@/Layouts/Link";
import Svg from "@/Components/Svg";
import {withViewItemBatcher} from "@/Context/ViewItemBatcherContext";
import '@/Pages/Collections/scss/awake.scss';

class Awake extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            videoSvg: false,
            videoPlayPauseFlag: true,
            videoNorthernLightsVolumeSvg: true,
        };
        this.videoRef = React.createRef();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.videoRef.current !== null) {
            const video = this.videoRef.current;
            video.onended = (e) => {
                video.muted = true;
                this.setState({
                    videoSvg: true,
                    videoNorthernLightsVolumeSvg: true
                })
            };
        }
    }

    videoTimer = () => setTimeout(() => {
        this.setState({videoPlayPauseFlag: false})
    }, 3000);

    /**
     * Убираем кнопку паузы на мобилке
     */
    mediaChangePlayPause = () => {
        try {
            if (!isDesktop()) {
                clearInterval(this.videoTimerId);
                if (!this.state.videoPlayPauseFlag) {
                    this.setState({videoPlayPauseFlag: true})
                }
                this.videoTimerId = this.videoTimer();
            }
        } catch (e) {
            console.log('e', e);
        }
    }

    /**
     * Воспроизведение / пауза видео
     */
    mediaChange = () => {
        try {
            const video = this.videoRef.current;
            if (video.paused) {
                video.play();
                this.setState({videoSvg: false})
            } else {
                video.pause();
                this.setState({videoSvg: true})
            }
            video.onended = (e) => {
                this.setState({videoSvg: true})
            };
        } catch (e) {
            console.log('e', e);
        }
    }

    /**
     * Управление звуком
     */
    mediaChangeVolume = () => {
        try {
            const video = this.videoRef.current;
            if (video.muted) {
                video.muted = false;
                this.setState({videoNorthernLightsVolumeSvg: false})
            } else {
                video.muted = true;
                this.setState({videoNorthernLightsVolumeSvg: true})
            }
        } catch (e) {
            console.log('e', e);
        }
    }


    render() {
        const {collectionDetailedData = {}, uploadUrl = '', registerView} = this.props;

        const {
            videoSvg,
            videoPlayPauseFlag,
            videoNorthernLightsVolumeSvg
        } = this.state;

        const category = dataCategory.map((item, i) => {
            return <Link key={i}
                             href={`/catalog/${item}/platina-awake`}
                             className={`category__item`}>
                <picture>
                    <source type={`image/webp`}
                            srcSet={`/storage/img/collections/awake/PLATINA-AWAKE-WEB-768x768-${item}-mobile.webp`}
                            media="(max-width: 767px)"
                    />
                    <source type={`image/webp`}
                            srcSet={`/storage/img/collections/awake/PLATINA-AWAKE-WEB-650x650-${item}.webp`}
                    />
                    <source srcSet={`/storage/img/collections/awake/PLATINA-AWAKE-WEB-768x768-${item}-mobile.jpg`}
                            media="(max-width: 767px)"
                    />
                    <img src={`/storage/img/collections/awake/PLATINA-AWAKE-WEB-650x650-${item}.jpg`}
                         alt={item}
                         title={item}
                         loading="lazy"
                         width={isMobile() ? "768" : "650"}
                         height={isMobile() ? "768" : "650"}
                    />
                </picture>
            </Link>
        });

        // Собираем карточки
        let dataOne = [], dataTwo = [], dataThree = [], dataFour = [], dataFive = [], dataSix = [], dataSeven = [];
        let offset = 0;
        if (Object.keys(collectionDetailedData).length > 0) {
            dataOne = collectionDetailedData.one.map((product, i) => {
                return <CatalogCard
                    key={product.id}
                    el={product}
                    {...this.props}
                    index={offset + i + 1}
                    registerView={registerView}
                />
            });
            offset += collectionDetailedData.one.length;
            // if (isMobile()) {
            //     dataOne = collectionDetailedData.one.map((el) => {
            //         return <CatalogCard key={el.id} el={el} {...this.props} />
            //     });
            //     dataThree = collectionDetailedData.three.map((el) => {
            //         return <CatalogCard key={el.id} el={el} {...this.props} />
            //     });
            //     dataFour = collectionDetailedData.four.map((el) => {
            //         return <CatalogCard key={el.id} el={el} {...this.props} />
            //     });
            //     dataSix = collectionDetailedData.six.map((el) => {
            //         return <CatalogCard key={el.id} el={el} {...this.props} />
            //     });
            // } else {
            //     dataOne = collectionDetailedData.one.map((el) => {
            //         return <CardModel key={el.id} el={el} {...this.props} />
            //     });
            //     dataThree = collectionDetailedData.three.map((el) => {
            //         return <CardModel key={el.id} el={el} {...this.props} />
            //     });
            //     dataFour = collectionDetailedData.four.map((el) => {
            //         return <CardModel key={el.id} el={el} {...this.props} />
            //     });
            //     dataSix = collectionDetailedData.six.map((el) => {
            //         return <CardModel key={el.id} el={el} {...this.props} />
            //     });
            // }
            //
            // // Стандартные карточки
            // dataTwo = collectionDetailedData.two.map((el) => {
            //     return <CatalogCard key={el.id} el={el} {...this.props} />
            // });
            // dataFive = collectionDetailedData.five.map((el) => {
            //     return <CatalogCard key={el.id} el={el} {...this.props} />
            // });
            // dataSeven = collectionDetailedData.seven.map((el) => {
            //     return <CatalogCard key={el.id} el={el} {...this.props} />
            // });
        }

        return <section className={`section`}>
            <div className={`collections-lp product`}>
                <div className={`container`}>
                    <div className={`svgAwakeTop`}>
                        <picture>
                            <source type={`image/webp`}
                                    srcSet={`/storage/img/collections/awake/logoAwake.webp`}
                            />
                            <img src={`/storage/img/collections/awake/logoAwake.png`}
                                 alt={`лого`}
                                 loading={`lazy`}
                                 width={`325`}
                                 height={`325`}
                            />
                        </picture>
                    </div>
                    <div className={`awake-wrapper`}>
                        <div className={`awake-wrapper__video-main`}>
                            <video ref={this.videoRef}
                                   autoPlay
                                   muted={`muted`}
                                   preload={`none`}
                                   width={`100%`}
                                   poster={'/storage/img/collections/awake/video-poster.jpg'}
                            >
                                <source
                                    src={`${uploadUrl}/media/video/collections/awake/PLATINA_AWAKE_1330x748.mp4`}
                                    type={`video/mp4`} />
                                <source
                                    src={`${uploadUrl}/media/video/collections/awake/PLATINA_AWAKE_1330x748.webm`}
                                    type={`video/webm`} />
                                <source
                                    src={`${uploadUrl}/media/video/collections/awake/PLATINA_AWAKE_1330x748.ogg`}
                                    type={`video/ogg`} />
                            </video>
                            <div className={`video-control`}
                                 onClick={() => this.mediaChangePlayPause()}>
                                {videoSvg ?
                                    <div className={`gg-play-button`} onClick={() => this.mediaChange()}></div>
                                    :
                                    <>
                                        {videoPlayPauseFlag && (
                                            <div className={`gg-pause-button`} onClick={() => this.mediaChange()}></div>
                                        )}
                                    </>
                                }
                                <div className={`volume`} onClick={() => this.mediaChangeVolume()}>
                                    {videoNorthernLightsVolumeSvg ?
                                        <Svg id={`volumeOffOutlinedIcon`} className={`svg__muted-off`} />
                                        :
                                        <Svg id={`volumeDownOutlinedIcon`} className={`svg__muted-on`} />
                                    }
                                </div>
                            </div>
                        </div>
                        <h1 className={`h1 h1__awake`}>
                            PLATINA AWAKE&nbsp;&mdash; оригинальные и&nbsp;современные украшения, вдохновлённые
                            уникальностью кофе! Бесценного дара природы, без которого сложно представить жизнь
                            современного человека. С&nbsp;аромата которого начинается утро. Энергия которого
                            дарит заряд бодрости на&nbsp;весь день.
                        </h1>
                        <p className={`awake-wrapper__description awake-wrapper__description_one`}>
                            PLATINA AWAKE&nbsp;&mdash; это понятные формы, комбинация оттенков металла
                            и&nbsp;роскошный блеск white-топазов. Это изящность силуэтов
                            и&nbsp;безукоризненность геометрических фигур, в&nbsp;которых воплощено природное
                            совершенство кофейного зерна.
                        </p>
                        <p className={`awake-wrapper__description awake-wrapper__description_two`}>
                            PLATINA AWAKE&nbsp;&mdash; это бесконечное пространство для экспериментов. Это
                            свобода выбора. Это акценты в&nbsp;образе, с&nbsp;которыми легко создать свой
                            уникальный и&nbsp;неповторимый стиль!
                        </p>
                        <div className={`cardWrapper`}>
                            {dataOne}
                        </div>
                        {/*<div className={`cardWrapper`}>*/}
                        {/*    {dataTwo}*/}
                        {/*</div>*/}
                        {/*<div className={`cardWrapper`}>*/}
                        {/*    {dataThree}*/}
                        {/*</div>*/}
                        {/*<div className={`cardWrapper`}>*/}
                        {/*    {dataFour}*/}
                        {/*</div>*/}
                        {/*<div className={`cardWrapper`}>*/}
                        {/*    {dataFive}*/}
                        {/*</div>*/}
                        {/*<div className={`cardWrapper`}>*/}
                        {/*    {dataSix}*/}
                        {/*</div>*/}
                        {/*<div className={`cardWrapper`}>*/}
                        {/*    {dataSeven}*/}
                        {/*</div>*/}
                        <div className={`category`}>
                            {category}
                        </div>
                        <Link href={`/catalog/platina-awake`} className={`btn btn__all-decorations btn__minima`}>
                            Все украшения
                        </Link>
                    </div>
                </div>
            </div>
        </section>
    }
}

const dataCategory = [
    'kolca',
    'sergi',
    'braslety',
    'podveski',
];

export default withViewItemBatcher(useWithStore(Awake));
